import type { ActionResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toAction } from './toAction';

function toActionDomain(args: { dtos: ActionResponse[] }) {
  const { dtos } = args;

  const actionDomain: NormalizedDomain<Data.Action> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      domainUtility.mutateAdd(actionDomain, toAction(item));
    },
  });

  return { actionDomain };
}

export { toActionDomain };
